import { render, staticRenderFns } from "./giftCardPrize.vue?vue&type=template&id=2750862a&scoped=true"
import script from "./giftCardPrize.vue?vue&type=script&lang=js"
export * from "./giftCardPrize.vue?vue&type=script&lang=js"
import style0 from "./giftCardPrize.vue?vue&type=style&index=0&id=2750862a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2750862a",
  null
  
)

export default component.exports